import { render, staticRenderFns } from "./ProductRangeSelection.vue?vue&type=template&id=2011c23e&scoped=true&"
import script from "./ProductRangeSelection.vue?vue&type=script&lang=js&"
export * from "./ProductRangeSelection.vue?vue&type=script&lang=js&"
import style0 from "./ProductRangeSelection.vue?vue&type=style&index=0&id=2011c23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011c23e",
  null
  
)

export default component.exports